import * as React from 'react'
import { SignupHeader } from '../headers/SignupHeader'
import { ErrorPanel } from './ErrorPanel'

interface ExpiredLinkPanelProps {
  title: string
  text: string
  icon?: string
}

const ExpiredLinkPanel = ({ title, text, icon = 'bi-hourglass-bottom' }: ExpiredLinkPanelProps) => (
  <>
    <SignupHeader hideAccountCreation />
    <ErrorPanel title={title} text={text} icon={icon} />
  </>
)

export default ExpiredLinkPanel
